(function(){
  var DELAY_MS = 30000;
  var RESHOW_DAYS = 90;
  var MIN_INTERACT_MS = 3000;
  var storageKey = 'od_email_popup';
  var shownAt = 0;

  // Disposable/spam email domains to block
  var blockedDomains = ['mailinator.com','tempmail.com','throwaway.email','guerrillamail.com',
    'guerrillamail.net','grr.la','sharklasers.com','guerrillamailblock.com','pokemail.net',
    'spam4.me','trashmail.com','trashmail.net','yopmail.com','yopmail.fr','tempail.com',
    'temp-mail.org','fakeinbox.com','mailnesia.com','maildrop.cc','dispostable.com',
    'getnada.com','emailondeck.com','33mail.com','inboxbear.com','mohmal.com',
    'tempinbox.com','burnermail.io','10minutemail.com','minutemail.com','tempr.email',
    'discard.email','discardmail.com','mailcatch.com','meltmail.com','harakirimail.com'];

  function getState(){
    try { return JSON.parse(localStorage.getItem(storageKey)) || {}; } catch(e){ return {}; }
  }
  function setState(obj){
    var s = getState();
    Object.keys(obj).forEach(function(k){ s[k] = obj[k]; });
    localStorage.setItem(storageKey, JSON.stringify(s));
  }

  var state = getState();
  if(state.submitted) return;
  if(state.dismissed){
    var diff = Date.now() - state.dismissed;
    if(diff < RESHOW_DAYS * 86400000) return;
  }

  // Build popup DOM
  var overlay = document.createElement('div');
  overlay.id = 'od-email-popup';
  overlay.style.cssText = 'display:none;position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,0.5);align-items:center;justify-content:center;';

  overlay.innerHTML = '<div style="background:#eddcf0;border-radius:16px;max-width:420px;width:90%;padding:36px 32px 32px;position:relative;box-shadow:0 20px 60px rgba(0,0,0,0.3);text-align:center;font-family:Assistant,sans-serif;">'
    + '<button id="od-popup-close-btn" style="position:absolute;top:12px;right:16px;background:none;border:none;font-size:22px;cursor:pointer;color:#333;line-height:1;">&times;</button>'
    + '<div id="od-popup-form">'
    + '<p style="font-size:1.05em;line-height:1.6;color:#1a1a2e;margin:0 0 16px;font-weight:500;">Master chairside 3D printing. Get clinical workflows, printing tips, and webinar invites for efficient same-day restorations.</p>'
    + '<p style="font-size:1.15em;font-weight:700;color:#1a1a2e;margin:0 0 24px;">Plus, $50 off your OCTOpod&trade; Starter Kit.</p>'
    + '<div style="position:relative;margin-bottom:16px;">'
    + '<svg style="position:absolute;left:14px;top:50%;transform:translateY(-50%);width:18px;height:18px;fill:#999;" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>'
    + '<input type="email" id="od-popup-email" placeholder="Enter your email address" style="width:100%;padding:14px 14px 14px 42px;border:1px solid #ccc;border-radius:8px;font-size:1em;font-family:inherit;box-sizing:border-box;outline:none;" required>'
    + '</div>'
    // Honeypot — hidden from humans, bots will fill it
    + '<div style="position:absolute;left:-9999px;top:-9999px;opacity:0;height:0;overflow:hidden;" aria-hidden="true">'
    + '<input type="text" id="od-popup-website" name="website" tabindex="-1" autocomplete="off">'
    + '</div>'
    + '<button id="od-popup-btn" style="width:100%;padding:14px;background:#7b2d8e;color:#fff;border:none;border-radius:8px;font-size:1.05em;font-weight:700;cursor:pointer;letter-spacing:0.5px;transition:background 0.2s;">Get Printing Tips</button>'
    + '<p id="od-popup-error" style="font-size:0.85em;color:#dc2626;margin:8px 0 0;display:none;"></p>'
    + '<p style="font-size:0.75em;color:#888;margin:12px 0 0;">No spam. Unsubscribe anytime.</p>'
    + '</div>'
    + '<div id="od-popup-success" style="display:none;">'
    + '<p style="font-size:1.3em;font-weight:700;color:#7b2d8e;margin:0 0 12px;">Welcome to OCTOdent.</p>'
    + '<p style="font-size:1.05em;color:#1a1a2e;margin:0 0 16px;line-height:1.6;">Check your inbox for your exclusive $50 discount code and upcoming clinical content.</p>'
    + '<button id="od-popup-shop-btn" style="width:100%;padding:14px;background:#7b2d8e;color:#fff;border:none;border-radius:8px;font-size:1.05em;font-weight:700;cursor:pointer;">Continue Browsing</button>'
    + '</div>'
    + '</div>';

  document.body.appendChild(overlay);

  // Show after delay
  setTimeout(function(){
    overlay.style.display = 'flex';
    shownAt = Date.now();
  }, DELAY_MS);

  // Dismiss
  function dismiss(){
    setState({dismissed: Date.now()});
    overlay.style.display = 'none';
  }

  document.getElementById('od-popup-close-btn').addEventListener('click', dismiss);
  overlay.addEventListener('click', function(e){
    if(e.target === overlay) dismiss();
  });

  // Submit with bot protection
  document.getElementById('od-popup-btn').addEventListener('click', function(){
    var errorEl = document.getElementById('od-popup-error');
    errorEl.style.display = 'none';

    // Honeypot check
    var honeypot = document.getElementById('od-popup-website');
    if(honeypot && honeypot.value.length > 0) {
      // Bot detected — fake success, don't save
      document.getElementById('od-popup-form').style.display = 'none';
      document.getElementById('od-popup-success').style.display = 'block';
      setState({submitted: Date.now()});
      return;
    }

    // Time gate check
    if(shownAt && (Date.now() - shownAt) < MIN_INTERACT_MS) {
      // Too fast — bot. Fake success.
      document.getElementById('od-popup-form').style.display = 'none';
      document.getElementById('od-popup-success').style.display = 'block';
      setState({submitted: Date.now()});
      return;
    }

    var emailInput = document.getElementById('od-popup-email');
    var email = emailInput.value.trim().toLowerCase();

    // Basic validation
    if(!email || email.indexOf('@') < 1 || email.indexOf('.') < 3) {
      emailInput.style.borderColor = '#dc2626';
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.style.display = 'block';
      return;
    }

    // Disposable email check
    var domain = email.split('@')[1];
    if(blockedDomains.indexOf(domain) !== -1) {
      emailInput.style.borderColor = '#dc2626';
      errorEl.textContent = 'Please use your professional email address.';
      errorEl.style.display = 'block';
      return;
    }

    // Suspicious pattern check — random dots in gmail (bot signature)
    if(domain === 'gmail.com') {
      var local = email.split('@')[0];
      var dotCount = (local.match(/\./g) || []).length;
      var letterCount = local.replace(/[^a-z]/g, '').length;
      var digitCount = local.replace(/[^0-9]/g, '').length;
      // Flag: many dots + short letter segments + ends in digits
      if(dotCount >= 4 && digitCount >= 1 && letterCount < 15) {
        // Likely bot — fake success
        document.getElementById('od-popup-form').style.display = 'none';
        document.getElementById('od-popup-success').style.display = 'block';
        setState({submitted: Date.now()});
        return;
      }
    }

    var btn = document.getElementById('od-popup-btn');
    btn.textContent = 'Subscribing...';
    btn.disabled = true;

    fetch('/contact', {
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded'},
      body: 'form_type=customer&utf8=%E2%9C%93&customer%5Bemail%5D=' + encodeURIComponent(email)
    }).then(function(){
      setState({submitted: Date.now(), email: email});
      document.getElementById('od-popup-form').style.display = 'none';
      document.getElementById('od-popup-success').style.display = 'block';
    }).catch(function(){
      setState({submitted: Date.now(), email: email});
      document.getElementById('od-popup-form').style.display = 'none';
      document.getElementById('od-popup-success').style.display = 'block';
    });
  });

  // Shop button closes
  document.getElementById('od-popup-shop-btn').addEventListener('click', function(){
    overlay.style.display = 'none';
  });

  // Enter key submits
  document.addEventListener('keydown', function(e){
    if(e.key === 'Enter' && overlay.style.display === 'flex'){
      document.getElementById('od-popup-btn').click();
    }
  });
})();

/* Contact Form Success Handler */
(function() {
  if (window.location.pathname.indexOf('/pages/contact') === -1) return;
  
  var STORAGE_KEY = 'od_contact_submitted';
  
  // CHECK: Did we just come back from a successful submission?
  var submitted = false;
  try { submitted = sessionStorage.getItem(STORAGE_KEY); } catch(e) {}
  
  if (submitted) {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch(e) {}
    
    document.addEventListener('DOMContentLoaded', function() {
      // Hide ALL contact forms and show success
      var forms = document.querySelectorAll('#contact_form, #ContactForm, .cp-form');
      forms.forEach(function(f) { f.style.display = 'none'; });
      
      // Hide "Send Us a Message" headings
      document.querySelectorAll('h2').forEach(function(h) {
        if (h.textContent.trim() === 'Send Us a Message') h.style.display = 'none';
      });
      
      // Show success banner in the right column
      var target = document.querySelector('.cp-right') || document.querySelector('#ContactForm');
      if (!target) return;
      var banner = document.createElement('div');
      banner.style.cssText = 'background-color:#f0fdf4;border:2px solid #22c55e;border-radius:12px;padding:32px 24px;text-align:center;margin:20px 0;';
      banner.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#22c55e" style="width:48px;height:48px;margin-bottom:12px;display:inline-block;"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg><h2 style="color:#15803d;font-size:1.5rem;margin-bottom:8px;">Message Sent Successfully!</h2><p style="color:#374151;font-size:1rem;margin:0;">Thank you for reaching out. We\'ll get back to you as soon as possible.</p>';
      if (target.parentNode) target.parentNode.insertBefore(banner, target);
    });
    return;
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    // HIDE the old cached form — it has no captcha support
    var oldForm = document.getElementById('contact_form');
    if (oldForm) {
      // Hide the entire old form section (it's inside a div wrapper)
      var wrapper = oldForm.closest('div[style]') || oldForm.parentNode;
      if (wrapper) wrapper.style.display = 'none';
    }
    
    // Use the REAL Shopify form — do NOT clone it (cloning breaks captcha)
    var shopifyForm = document.getElementById('ContactForm');
    if (!shopifyForm) return;
    
    // Add submit listener to set the success flag — let Shopify handle the actual submit
    shopifyForm.addEventListener('submit', function() {
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch(e) {}
    });
  });
})();
